// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".edit-table[data-v-537424fd] {\n  padding-left: 50px;\n}\n.box[data-v-537424fd] {\n  display: flex;\n}\n.text[data-v-537424fd] {\n  margin-left: 10px;\n}\n.icon-style-jia[data-v-537424fd] {\n  color: #c34231;\n  font-weight: bold;\n  margin-left: 10px;\n}\n", ""]);
// Exports
module.exports = exports;
